import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function updateLeadApi({id,data}) {
    return ApiRequest.fetchAdmin({
      method: "put",
      url: `${API_END_POINTS.UPDATE_LEAD}/${id}`,
      data,
    }).then((response) => response.data.lead);
  }